<template lang="pug">
  form#maybank-form(v-if="payment !== null")
    .md-form-group(:class="{'invalid':errors.has('maybank_client_qr_id')}")
      input.md-input(
        type="text"
        name="maybank_client_qr_id"
        v-model="payment.meta.maybank_client_qr_id"
        v-validate="'required'"
        data-vv-as="Client QR ID"
        :disabled="loading"
      )
      label Client QR ID
      span.form-error-msg(v-show="errors.has('maybank_client_qr_id')") {{ errors.first('maybank_client_qr_id') }}

    div.md-form-group.p-t-0
      label.multiselect-label Applicable outlets
      multiselect(
      name="outlets"
      v-model="payment.outlets"
      :options="outletList"
      placeholder="Type to search"
      label="name"
      :multiple="true"
      :loading="outletList.length === 0"
      :disabled="loading"
      :clear-on-select="false"
      :close-on-select="false"
      :hide-selected="true"
      track-by="id"
      )
      span.md-input-msg Leave empty if applicable to all outlets.
</template>

<script>
import FormMixin from '../form-mixin';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'Maybank',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'maybank_qrpay',
                meta: {},
                outlets: [],
            }),
        },
    },

    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);

            return Object.assign(payment, {
                name: 'Maybank QrPay',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'maybank_qrpay',
                outlets: this.payment.outlets.map(obj => obj.id),
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/maybank-form.vue